"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @hidden */
exports.assert = function (condition, message) {
    if (!condition) {
        throw new Error(message);
    }
};
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/~/@angular-redux/store/lib/src/utils/assert.js
// module id = ../../../../@angular-redux/store/lib/src/utils/assert.js
// module chunks = 3